module.exports = "/images/pt-30.svg?a5302050c57a15aeff0a18ccbf3acae6";